import MainLayout from "@/components/layout/MainLayout.vue";
import RegionJson from "@/assets/json/region.json";
import axios from "axios";
import store from "@/store";
import { mapGetters } from "vuex";
import { fetchNotificationCount } from "@/services/common/notification-service";

export default {
  name: "detailSchool",

  components: {
    MainLayout
  },

  data() {
    return {
      school: {},
      reloadKey: 0,
      regionArr: RegionJson
    };
  },

  computed: {
    ...mapGetters(["teacherId", "studentId", "schoolId", "userType"]),
  },

  methods: {
    getDetailSchool() {
      axios.get("/profile")
        .then((response) => {
          this.school = response.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('/');
          }
          console.log("School Detail API Error", error);
        });
    },

    checkSchoolToken(token) {
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
      axios.get("/token/school")
        .then((response) => {
          response.data.token = token;
          store.commit("setUserData", response.data);
          this.school = response.data.school;
          this.reloadKey += 1;
          this.$router.push({ name: "detailSchool" });
        })
        .catch((error) => {
          console.log("School Detail API Error", error);
        });
    },
  },

  created() {
    fetchNotificationCount();

    if (this.$route.query.token) {
      this.checkSchoolToken(this.$route.query.token);
    } else {
      this.getDetailSchool();
    }
  }
};
